<template lang="pug">
  .payment-methods
    .payment-methods__header
      h1 {{$t('payment_methods')}}
      p {{$t('payment_methods_subtitle')}}
    .payment-methods__body
      div(v-for="(item,key) in data", :key="key")
        .payment-methods__body-item.item(:class="{active: item.ID === selectedMethod.ID}", @click="selectMethod(item)", :data-qa="'payment-method-item-' + item.ID")
          .item-info
            img(:src="item.IMAGE" v-if="item.IMAGE && item.IMAGE !== null")
            p {{ item.NAME }}
          .item__icons.icons(:class="{'icons__bank-card': isCardIconsVisible(item)}")
            .icons__cards(v-if="isCardIconsVisible(item)")
              IconApplePay
              IconGPay
              IconMasterCard
              IconVisa
            .item-circle
        Notification(
          v-if="showNotification(item)",
          :text="$t(`${notificationText}`)",
          class="notifi",
        )
</template>

<script>
import Notification from './Notification.vue'
import IconMasterCard from '@/components/svg/IconMasterCard.vue'
import IconVisa from '@/components/svg/IconVisa.vue'
import IconApplePay from '@/components/svg/IconApplePay.vue'
import IconGPay from '@/components/svg/IconGPay.vue'
import { mapState } from 'vuex'
import { notificationText } from '@/utils/notificationTextGenerator.js'
import { WALLETTO_IDS } from '@/consts/wallettoIds.js'

export default {
  name: 'PaymentMethods',
  components: {
    IconGPay,
    IconApplePay,
    IconVisa,
    IconMasterCard,
    Notification,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    orderPaymentType: {
      type: [Object, String],
    },
  },
  data() {
    return {
      selectedMethod: {},
    }
  },

  computed: {
    ...mapState(['CUR_LOCATION']),
    showNotification() {
      return (item) => {
        return this.selectedMethod.ID === item.ID && !!this.notificationText
      }
    },
    notificationText() {
      return notificationText(this.selectedMethod.ID, this.CUR_LOCATION)
    },
  },

  methods: {
    selectMethod(item) {
      this.selectedMethod = item
      this.$emit('selectMethod', item)
    },
    isCardIconsVisible(item) {
      return WALLETTO_IDS.includes(item.ID)
    },
  },

  watch: {
    orderPaymentType() {
      if (this.orderPaymentType?.ID) {
        this.selectedMethod = this.orderPaymentType
      } else {
        setTimeout(() => {
          this.data.forEach((el) => {
            if (el.ID === this.orderPaymentType) {
              this.selectedMethod = el
            }
          })
        }, 1000)
      }
    },
  },

  mounted() {
    if (this.orderPaymentType?.ID) {
      this.selectedMethod = this.orderPaymentType
    } else {
      this.data.forEach((el) => {
        if (el.ID === this.orderPaymentType) {
          this.selectedMethod = el
        }
      })
    }
  },
}
</script>

<style lang="scss">
.payment-methods {
  width: 100%;
  display: flex;
  flex-direction: column;

  &__header {
    display: flex;
    flex-direction: column;
    gap: 6px;
    padding: 16px 2px;

    h1 {
      font-size: 32px;
      font-weight: 500;
      line-height: 32px;
      color: #333f48;
    }

    p {
      font-size: 16px;
      font-weight: 400;
      line-height: 20px;
      color: #646d74;
    }
  }

  &__body {
    display: flex;
    flex-direction: column;
    gap: 12px;

    .item {
      padding: 12px 16px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
      cursor: pointer;
      border: 1px solid #e2e8f0;
      border-radius: 12px;

      @media (max-width: 480px) {
        flex-wrap: wrap;
      }

      &.active {
        border: 1px solid #fa5f55;

        .item-circle {
          width: 16px;
          height: 16px;
          border: 4px solid #fa5f55;
          border-radius: 50%;
        }
      }

      &-info {
        display: flex;
        align-items: center;
        gap: 8px;

        img {
          width: 32px;
          height: 32px;
        }

        p {
          font-size: 16px;
          line-height: 20px;
          color: #333f48 !important;
        }
      }

      &-circle {
        width: 16px;
        height: 16px;
        border: 1px solid #858c91;
        border-radius: 50%;
      }

      &__icons {
        display: flex;
        align-items: center;
        gap: 24px;
      }

      .icons {
        &__cards {
          display: flex;
          align-items: center;
          gap: 6px;
        }

        &__bank-card {
          @media screen and (max-width: 480px) {
            justify-content: space-between;
            width: 100%;
          }
        }
      }
    }

    .notifi {
      margin-top: 18px;
    }
  }
}
</style>
